<template>
    <main id="main-container">
      <Hero title="Usuarios de Monitoreo" page="Monitor-Admin" />
      <div class="content">
        <h2>Menu</h2>
        <div class="row">
          <Card title="Crear Nueva Cuenta de Monitoreo">
            <div class="row">
              <form class="form-class" @submit.prevent="createEmailRegistration">
                <div class="col-md-6 col-12">
                  <label for="" class="form-label">Email</label>
                  <input
                    class="form-control"
                    label="Email"
                    type="text"
                    placeholder="My Email"
                    v-model="data.new_account.email"
                    required
                  />
                </div>
                <br />
                <a :href="data.new_account.link" class="col-12">{{ data.new_account.link }}</a>
                <div class="col-12 my-1" v-if="data.new_account.link != ''">
                  <button
                    class="btn btn-info mb-3 pull-left"
                    @click="copyClipboard"
                  >
                  <i class="fa fa-clipboard mx-1" ></i>
                    Copiar
                  </button>
                </div>
                <div class="col-12">
                  <button type="submit" class="btn btn-info mb-3 pull-right">
                    Crear
                  </button>
                </div>
              </form>
            </div>
          </Card>
        </div>
        <!-- Client TABLE -->
        <div class="row">
          <Card title="Lista de Usuarios Monitores">
            <div class="table-responsive">
              <table class="table table-bordered table-striped table-vcenter">
                <thead>
                  <th>#</th>
                  <th>Nombre</th>
                  <th>Email</th>
                  <th class="text-center" style="width: 100px">Activo</th>
                  <th class="text-center" style="width: 100px">Borrar</th>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in data.users_data" v-bind:key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ row.name }}</td>
                    <td>{{ row.email }}</td>
                    <td>
                      <div class="form-check form-switch">
                        <i
                          class="fa fa-user"
                          :class="{
                            'text-success': row.is_active,
                            'text-dark': !row.is_active,
                          }"
                        ></i>                          
                        <input
                          class="form-check-input"
                          @click="showAlertConfirm( `${!row.is_active ? 'Activar' : 'Desactivar'} Usuario -> ${row.name}  ?` ,
                                      'Confirma Si deseas Cambiar el Estado del Usuario Monitor Seleccionado ?',
                                      'question',
                                      'update',
                                      row
                                      )"
                          v-model="row.is_active"
                          type="checkbox"
                        />
                      </div>
                    </td>
                    <td>
                    <button class="btn btn-danger mx-3" @click="
                    showAlertConfirm( `Borrar Usuario -> ${row.name}  ?` ,
                                      'Confirma Si deseas Borrar el Usuario Monitor Seleccionado ?',
                                      'question',
                                      'delete',
                                      row
                                      )"
                      >
                        <i class="fa fa-times"></i>
                    </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      </div>
    </main>
  </template>
  
  <script>
  import useMonitorUsers from '@/composables/useMonitorUsers';
  export default {
    name: "monitor-users",
    setup() {
      const {data,updateUserStatus,createEmailRegistration,copyClipboard, deleteMonitorUser, showAlertConfirm} = useMonitorUsers()

      return {
        data,
        createEmailRegistration,
        copyClipboard,
        showAlertConfirm
      }
    }
  };
  </script>
  